<template>
  <div>
    <div style="padding-top: 10px;display: flex;justify-content: space-between">
      <div>
        <el-select style="width: 270px;float: left;" v-model="type" @change="initMessage()">
          <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-plus" @click="showAddMessage()">发布消息</el-button>
      </div>
    </div>
    <div style="margin-top: 10px;">
      <el-table
          v-loading="loading"
          @selection-change="handleSelectionChange"
          :data="messageList"
          border
          style="width: 100%">
        <el-table-column
            type="selection"
            width="55">
        </el-table-column>
        <el-table-column
            label="发布人" width="150">
          <template slot-scope="scope">
            <el-link type="primary" @click="getUserInfo(scope.row.fromUserId)">{{ scope.row.fromNickname }}</el-link>
          </template>
        </el-table-column>
        <el-table-column
            prop="title"
            label="标题"
            width="380">
        </el-table-column>
        <el-table-column
            prop="date"
            label="日期"
            width="150">
        </el-table-column>
        <el-table-column
            label="接收人" width="150">
          <template slot-scope="scope">
            <el-link type="success" v-if="scope.row.toUserId!==0" @click="getUserInfo(scope.row.toUserId)">
              {{ scope.row.toNickname }}
            </el-link>
            <el-link disabled v-if="scope.row.toUserId===0">所有用户</el-link>
          </template>
        </el-table-column>
        <el-table-column
            label="类型"
            width="100">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type===0">系统</el-tag>
            <el-tag type="warning" v-if="scope.row.type===1">圈子</el-tag>
          </template>
        </el-table-column>
        <el-table-column
            label="操作">
          <template slot-scope="scope">
            <el-button @click="showEditMessage(scope.row)">编辑</el-button>
            <el-button type="danger" @click="deleteMessage(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top:10px;display: flex;justify-content: space-between">
        <el-button type="danger" size="small"
                   :disabled="this.multipleSelection.length===0"
                   @click="deleteMany">批量删除({{ this.multipleSelection.length }})
        </el-button>
        <el-pagination
            background
            @current-change="currentChange"
            @size-change="sizeChange"
            layout="sizes,prev, pager, next, jumper, ->, total"
            :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog
        title="编辑消息"
        :visible.sync="editDialogVisible"
        width="70%" style="z-index: 99;">
      <div>
        <el-form ref="editMessageForm" :model="message" :rules="messageRules">
          <el-form-item label="标题" prop="title">
            <el-input style="width: 500px" v-model="message.title"
                      placeholder="请输入标题"></el-input>
          </el-form-item>
          <!--          <el-form-item label="类型" prop="type">-->
          <!--            <el-radio v-model="news.type" label="0" border size="medium">学校新闻</el-radio>-->
          <!--            <el-radio v-model="news.type" label="2" border size="medium">学校通知</el-radio>-->
          <!--            <el-radio v-model="news.type" label="1" border size="medium">党务活动</el-radio>-->
          <!--          </el-form-item>-->
          <el-form-item prop="content">
            <vue-tinymce
                v-model="message.content"
                :setting="setting"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="editDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="doEditor()">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        title="发布消息"
        :visible.sync="addMessageDialogVisible"
        width="70%">
      <div>
        <el-form ref="addMessageForm" :model="addMessage" :rules="messageRules">
          <el-form-item label="标题" prop="title">
            <el-input style="width: 500px" v-model="addMessage.title"
                      placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item prop="content">
            <vue-tinymce
                v-model="addMessage.content"
                :setting="setting"/>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="addMessageDialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="saveMessage()">确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
        :visible.sync="userDialogVisible"
        width="50%" style="min-width: 350px">
      <div v-if="userInfoLoading">
        <el-descriptions :colon="false">
          <el-descriptions-item :colon="false">
            <el-avatar :size="70" :src="userInfo.avatarUrl"></el-avatar>
          </el-descriptions-item>
<!--          <el-descriptions-item label="用户名:">{{ userInfo.username }}</el-descriptions-item>-->
          <el-descriptions-item label="昵称:">{{ userInfo.nickname }}</el-descriptions-item>
          <el-descriptions-item label="学校:">
            <el-tag size="small">{{ userInfo.schoolName }}</el-tag>
          </el-descriptions-item>
          <el-descriptions-item label="认证信息:">
            {{ userInfo.intro }}
          </el-descriptions-item>
        </el-descriptions>
      </div>
      <span slot="footer" class="dialog-footer">
    <el-button type="primary" @click="userDialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'NoticeList',
  data() {
    return {
      loading: false,
      message: '',
      messageList: [],
      serverUrl:this.GLOBAL.serverUrl,
      total: 0,
      multipleSelection: [],
      currentPage: 1,
      size: 10,
      editDialogVisible: false,
      userDialogVisible: false,
      addMessageDialogVisible: false,
      userInfoLoading: false,
      userInfo: null,
      type: -1,
      options: [{
        value: -1,
        label: '所有'
      }, {
        value: 0,
        label: '系统'
      }, {
        value: 1,
        label: '圈子'
      }],
      setting: {
        convert_urls: false,
        menubar: true,
        toolbar: "undo redo| preview | fullscreen | formatselect alignleft aligncenter alignright alignjustify | link unlink | numlist bullist | image media table | fontselect fontsizeselect forecolor backcolor | bold italic underline strikethrough | indent outdent | superscript subscript | removeformat | importword | kityformula-editor | hr | directionality | indent2em | lineheight",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar: "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "preview link image media table lists fullscreen quickbars code codesample importword imagetools kityformula-editor hr directionality indent2em lineheight",
        //  images_upload_url: '/editor/upload',
          images_upload_base_path: this.GLOBAL.serverUrl+'/',
        images_upload_credentials: true,
        language: 'zh_CN', //本地化设置
        height: 500,
        images_upload_handler: (blobInfo, succFun, failFun) => {
          var serverUrl = this.GLOBAL.serverUrl
          var xhr, formData;
          var file = blobInfo.blob();//转化为易于理解的file对象
          xhr = new XMLHttpRequest();
          xhr.withCredentials = false;
          xhr.open('POST', '/api/editor/upload'); //this.GLOBAL.serverUrl+
          xhr.setRequestHeader('Authorization', window.sessionStorage.getItem('tokenStr'))
          xhr.onload = function (){
            var json;
            if (xhr.status != 200) {
              failFun('HTTP Error: ' + xhr.status);
              return;
            }
            json = JSON.parse(xhr.responseText);
            if (!json || typeof json.location != 'string') {
              failFun('Invalid JSON: ' + xhr.responseText);
              return;
            }
           // var path = this.GLOBAL.serverUrl + json.location
           // var path = serverUrl + json.location
            var path =  json.location
            succFun(path);
          };
          // this.uploadPostRequest('/editor/upload',file).then(resp=>{
          //   if(resp){
          //     succFun(resp.location)
          //   }
          // })
          formData = new FormData();
          formData.append('file', file, file.name);//此处与源文档不一样
          xhr.send(formData);
        }
      },
      messageRules: {
        title: [{
          required: true,
          message: '请输入标题',
          trigger: blur
        }],
        content: [{
          required: true,
          message: '请输入消息内容',
          trigger: blur
        }]
      },
      addMessage: {
        title: '',
        content: ''
      }
    }
  },
  mounted() {
    this.initMessage()
  },
  methods: {
    doEditor() {
      this.$refs['editMessageForm'].validate(valid => {
        if (valid) {
          this.putRequest('/message/', this.message).then(resp => {
            if (resp) {
              this.editDialogVisible = false
              this.initMessage()
            }
          })
        } else {
          this.$message('标*字段不能为空')
        }
      })
    },
    showEditMessage(data) {
      this.postRequest('/message/web/' + data.id).then(resp => {
        if (resp) {
          this.editDialogVisible = true
          this.message = resp
        }
      })
    },
    showAddMessage() {
      this.addMessage = {
        title: '',
        content: ''
      }
      this.addMessageDialogVisible = true;
    },
    saveMessage() {
      this.$confirm('确定发布此消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$refs['addMessageForm'].validate(valid => {
          if (valid) {
            this.postRequest('/message/web/add', this.addMessage).then(resp => {
              if (resp) {
                this.type = -1
                this.addMessageDialogVisible = false
                this.initMessage()
              }
            })
          } else {
            this.$message('标*字段不能为空')
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消操作'
        })
      })
    },
    deleteMessage(message) {
      this.$confirm('此操作将永久删除【' + message.title + '】消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteRequest('/message/web/' + message.id).then(resp => {
          if (resp) {
            this.initMessage()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    deleteMany() {
      this.$confirm('此操作将永久删除' + this.multipleSelection.length + '条消息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let ids = '?'
        this.multipleSelection.forEach(item => {
          ids += 'ids=' + item.id + '&'
        })
        this.deleteRequest('/message/web/' + ids).then(resp => {
          if (resp) {
            this.initMessage()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    sizeChange(size) {
      this.size = size
      this.initMessage()
    },
    currentChange(currentPage) {
      this.currentPage = currentPage
      this.initMessage()
    },
    initMessage() {
      this.loading = true
      this.getRequest('/message/web/list?currentPage=' + this.currentPage + '&size=' + this.size + '&type=' + this.type).then(resp => {
        if (resp) {
          this.messageList = resp.data
          this.total = resp.total
          this.loading = false
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    getUserInfo(userId) {
      this.userDialogVisible = true
      this.postRequest('/message/web/userInfo?id=' + userId).then(resp => {
        if (resp) {
          this.userInfo = resp
        }
        this.userInfoLoading = true
      })
    },
  }
}
</script>

<style scoped>
.tox-tinymce-aux {
  z-index: 5000 !important;
}
</style>
